import React from 'react';
import './ResponsiveLayout.css';

interface ResponsiveLayoutProps {
  children: React.ReactNode;
  className?: string;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  padding?: 'none' | 'sm' | 'md' | 'lg' | 'xl';
  centered?: boolean;
  fullHeight?: boolean;
}

export const ResponsiveLayout: React.FC<ResponsiveLayoutProps> = ({
  children,
  className = '',
  maxWidth = 'lg',
  padding = 'md',
  centered = false,
  fullHeight = false,
}) => {
  const classes = [
    'responsive-layout',
    `responsive-layout--${maxWidth}`,
    `responsive-layout--padding-${padding}`,
    centered && 'responsive-layout--centered',
    fullHeight && 'responsive-layout--full-height',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      <div className="responsive-layout__content">
        {children}
      </div>
    </div>
  );
};

interface ResponsiveGridProps {
  children: React.ReactNode;
  className?: string;
  columns?: {
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
  };
  gap?: 'sm' | 'md' | 'lg' | 'xl';
}

export const ResponsiveGrid: React.FC<ResponsiveGridProps> = ({
  children,
  className = '',
  columns = { xs: 1, sm: 2, md: 3, lg: 4 },
  gap = 'md',
}) => {
  const classes = [
    'responsive-grid',
    `responsive-grid--gap-${gap}`,
    columns.xs && `responsive-grid--xs-${columns.xs}`,
    columns.sm && `responsive-grid--sm-${columns.sm}`,
    columns.md && `responsive-grid--md-${columns.md}`,
    columns.lg && `responsive-grid--lg-${columns.lg}`,
    columns.xl && `responsive-grid--xl-${columns.xl}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      {children}
    </div>
  );
};

interface ResponsiveStackProps {
  children: React.ReactNode;
  className?: string;
  direction?: 'column' | 'row';
  breakpoint?: 'sm' | 'md' | 'lg';
  gap?: 'sm' | 'md' | 'lg' | 'xl';
  align?: 'start' | 'center' | 'end' | 'stretch';
  justify?: 'start' | 'center' | 'end' | 'between' | 'around';
}

export const ResponsiveStack: React.FC<ResponsiveStackProps> = ({
  children,
  className = '',
  direction = 'column',
  breakpoint,
  gap = 'md',
  align = 'stretch',
  justify = 'start',
}) => {
  const classes = [
    'responsive-stack',
    `responsive-stack--${direction}`,
    breakpoint && `responsive-stack--${breakpoint}-row`,
    `responsive-stack--gap-${gap}`,
    `responsive-stack--align-${align}`,
    `responsive-stack--justify-${justify}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      {children}
    </div>
  );
};